import useSessionStorage from './useSessionStorage';

export function useExampleData(): [boolean, (newVal: boolean) => void] {
  return useSessionStorage<boolean>('example-data', true);
}
